module.exports = __webpack_public_path__ + "img/consultoria2_4-3_2048.4fbc00f2.jpg";